<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="header-title mt-0">{{titles.clientListExpression}}</h4>
                    <b-row class="mb-2">
                        <TablePerPageSelect :perPage="perPage" @method="setPerPage"/>
                        <TableAddButton :nameButton="titles.clientAddExpression"
                                        :showAddButton="showAddButton"
                                        pathName="addClient"
                                        v-if="!$route.path.includes('commercial')"/>
                    </b-row>
                    <b-table
                            :current-page="currentPage"
                            :emptyText="titles.emptyData"
                            :fields="fields"
                            :items="items"
                            :per-page="0"
                            :responsive="true"
                            @sort-changed="sortingChanged"
                            class="vouchers-table"
                            id="team-table"
                            no-local-sorting
                            show-empty
                    >
                        <template #empty="scope">
                            <Loading v-if="inProgess"/>
                            <p class="emptyData" v-if="!inProgess">{{ scope.emptyText }}</p>
                        </template>
                        <template v-slot:head(Actions)>
                            <TableIconFilter :showFilter="showFilter" @changeValShowFilter="changeValShowFilter"/>
                        </template>
                        <template class="search-input" v-if="showFilter" v-slot:top-row>
                            <TableFilterInput @method="debouncedFetchClient" name="firstName" placeholder="Prénom"/>
                            <TableFilterInput @method="debouncedFetchClient" name="lastName" placeholder="Nom"/>
                            <TableFilterInput @method="debouncedFetchClient" name="email" placeholder="Email"/>
                            <TableFilterTypeahead :country="countries" @method="debouncedFetchClient"
                                                  placeholder="Nom du pays"/>
                            <span></span>
                            <TableFilterDatePicker @method="debouncedFetchClient" name="lastLogin"
                                                   placeholder="DD/MM/YYYY"/>
                            <TableFilterSelect :options="etatSearch"
                                               :text="'text'"
                                               :val="'value'"
                                               @method="debouncedFetchClient"
                                               name="isClient"
                                               placeholder="Etat"/>
                            <TableFilterSelect :options="enabledOptions"
                                               :text="''"
                                               :val="'value'"
                                               @method="debouncedFetchClient"
                                               name="enabled"
                                               placeholder="Statut"/>
                        </template>
                        <template v-slot:cell(enabled)="data">
                            <i
                                    class="fas fa-check font-20 text-success"
                                    v-if="data.value"
                            ></i>
                            <i
                                    class="fas fa-times font-20 text-danger"
                                    v-if="!data.value"
                            ></i>
                        </template>
                        <template v-slot:cell(lastLogin)="data">
                            <span v-if="data.value">
                                <span v-if="((new Date(data.value).getDate()).toString()).length == 1">0</span>{{new Date(data.value).getDate()}}/<span v-if="((new Date(data.value).getMonth() +1).toString()).length == 1">0</span>{{new Date(data.value).getMonth() +1 }}/{{new Date(data.value).getFullYear()}}
                            </span>
                            <span v-if="!data.value">-------------</span>
                        </template>
                        <template v-slot:cell(isClient)="data">
                            <span v-if="data.value">Client</span>
                            <span v-else>Prospect</span>
                        </template>
                        <template v-slot:cell(country)="data">
                            <img
                                    :src=" require('@/assets/images/flags/' + data.value.code.toLowerCase() + '.svg') "
                                    v-if="data.value"
                                    width="25"
                            />
                            <span v-if="data.value"> {{data.value.name}} </span>
                            <span v-if="!data.value">-------------</span>
                        </template>
                        <template v-slot:cell(voucher.expiresAt)="data">
                            <span v-if="!data.item.voucher">-------------</span>
                            <span class="badge font-12 w-100 badge-soft-danger"
                                  v-if="data.item.voucher && tableList.dateDiff(data.item.voucher.expiresAt) <= 0">Expiré</span>
                            <span class="badge font-12 w-100 badge-soft-warning"
                                  v-else-if=" data.item.voucher && tableList.dateDiff(data.item.voucher.expiresAt) > 0 && tableList.dateDiff(data.item.voucher.expiresAt) <= 7 ">-{{ tableList.dateDiff(data.item.voucher.expiresAt) }} jours</span>
                            <span class="badge font-12 w-100 badge-soft-primary"
                                  v-else-if="data.item.voucher && tableList.dateDiff(data.item.voucher.expiresAt) > 7">-{{ tableList.dateDiff(data.item.voucher.expiresAt) }} jours</span>
                        </template>
                        <template v-slot:cell(Actions)="data">
                            <TableEditInfoElement
                                    :params="{ id: data.item.id, clientItem: data.item, isEditable: isEditable }"
                                    :selectedItem="data.item"
                                    name='UpdateClient'/>

                            <TableDeleteElement :id="data.item.id" @method="deleteClient"/>
                        </template>
                    </b-table>
                    <TablePagination :currentPage="currentPage" :perPage="perPage" :rows="rows"
                                     @method="setCurrentPage"/>
                </div>
                <!--end card-body-->
            </div>
            <!--end card-->
        </div>
        <!--end col-->
    </div>
    <!--end row-->
</template>

<script>
    import {
        deleteUser,
        getAllClients
    } from '@/components/shared/services/user.service';
    import {filterMixin} from '@/utils/filterMixin';
    import {debounce} from 'vue-debounce';
    import TablePerPageSelect from '@/components/common/TablePerPageSelect';
    import TableAddButton from '@/components/common/TableAddButton';
    import TableIconFilter from '@/components/common/TableIconFilter';
    import TableEditInfoElement from '@/components/common/TableEditInfoElement';
    import TableDeleteElement from '@/components/common/TableDeleteElement';
    import TablePagination from '@/components/common/TablePagination';
    import TableFilterInput from '@/components/common/TableFilterInput';
    import TableFilterDatePicker from '@/components/common/TableFilterDatePicker';
    import TableFilterSelect from '@/components/common/TableFilterSelect';
    import TableFilterTypeahead from '@/components/common/TableFilterTypeahead';
    import {tableList} from '../../../utils/general/tableList';
    import {titles} from '../../../utils/general/titles.js';
    import {getAllCountriesJson} from '../../shared/services/country.service';
    import {country} from '../../shared/models/country';
    import Loading from '../../common/Loading';
    import {errorMixin} from '../../../utils/errorMixin';

    export default {
        name: 'clients-table',
        components: {
            Loading,
            TablePerPageSelect,
            TablePagination,
            TableAddButton,
            TableIconFilter,
            TableDeleteElement,
            TableEditInfoElement,
            TableFilterInput,
            TableFilterDatePicker,
            TableFilterSelect,
            TableFilterTypeahead
        },
        props: {
            okPressed: {
                type: Boolean,
                required: false
            },
            showAddButton: {
                type: Boolean,
                default: true
            },
            clientAdded: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                tableList,
                titles,
                userId: null,
                query: 'country',
                value: '',
                statusOptions: [
                    {text: 'Confirmé', value: 'true'},
                    {text: 'Non confirmé', value: 'false'}
                ],
                countries: null,
                selected: null,
                enabledOptions: [
                    {
                        text: 'Confirmé',
                        value: 1,
                        icon: 'fas fa-check font-20 text-success'
                    },
                    {
                        text: 'Non Confirmé',
                        value: 0,
                        icon: 'fas fa-times font-20 text-danger'
                    }
                ],
                etatSearch: [
                    {
                        text: 'Prospect',
                        value: 0
                    },
                    {
                        text: 'Client',
                        value: 1
                    }
                ],
                filterList: [],
                filterQuery: '',
                expires: 0,
                txtInput: '',
                sort: '',
                perPage: 10,
                currentPage: 1,
                showFilter: false,
                rows: null,
                sortType: '',
                isClient: false,
                fields: [
                    {key: 'firstName', label: 'Prénom', sortable: true},
                    {key: 'lastName', label: 'Nom', sortable: true},
                    {key: 'email', label: 'Email', sortable: true},
                    {key: 'country', label: 'Pays', sortable: false},
                    {key: 'voucher.expiresAt', label: 'Code Promo', sortable: false},
                    {key: 'lastLogin', label: 'Dernière Action', sortable: true},
                    {key: 'isClient', label: 'Etat', sortable: false},
                    {key: 'enabled', label: 'Statut', sortable: true, tdClass: 'text-center'},
                    {key: 'Actions', sortable: false, thClass: 'text-center'}
                ],
                items: [],
                isEditable: true,
                inProgess: true
            };
        },
        mixins: [filterMixin, errorMixin],
        created() {
            getAllCountriesJson().then(response => {
                this.castCountry(response);
            });
            this.$cookies.remove('editClientPage');
            this.$cookies.remove('clientItemIsEditable');
            this.$cookies.remove('packCountryDomainDetailItem');
            this.$cookies.remove('subscriptionItem');
            this.$cookies.remove('organisationItem');
            this.$cookies.remove('organisationDetailItem');
            this.$cookies.remove('organisationItemIsEditable');
            this.orderQueryGenerator('created', true);
        },
        methods: {
            castCountry(response) {
                this.countries = response.data.map(item => country(item));
            },
            deleteClient(id) {
                this.$bvModal.show('success-delete-user');
                this.userId = id;
            },
            debouncedFetchClient: debounce(function (column, val, type, direction) {
                this.fetchClients(column, val, type, direction);
            }, 300),
            sortingChanged(ctx) {
                this.orderQueryGenerator(ctx.sortBy, ctx.sortDesc);
                this.fetchClients();
            },
            changeValShowFilter(val) {
                this.showFilter = val;
            },
            setCurrentPage(val) {
                this.currentPage = val;
            },
            setPerPage(val) {
                this.perPage = val;
            },
            async fetchClients(column, val, type) {
                this.inProgess = true;
                this.items = [];
                if (column) {
                    this.filterList = this.filterQueryGenerator(
                        this.filterList,
                        column,
                        val,
                        type
                    );
                    if (val == undefined) {
                        let noFilter = false;
                        for (let i = 0; i < this.filterList.length; i++) {
                            noFilter = Object.values(this.filterList[i]).includes(column);
                            if (noFilter) {
                                this.filterList.splice(i, 1);
                            }
                        }
                    }
                }
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'deleted',
                    false,
                    null
                );
                getAllClients(
                    this.perPage,
                    this.currentPage,
                    this.sort,
                    this.filterQuery
                ).then(response => {
                    this.items = response.data['hydra:member'];
                    this.rows = response.data['hydra:totalItems'];
                    this.inProgess = false;
                });
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.debouncedFetchClient('parent', this.$route.params.id);
            } else {
                this.fetchClients();
            }
        },
        watch: {
            okPressed() {
                if (this.okPressed) {
                    deleteUser(this.userId).then(
                        response => {
                            if (response.data == 'Cannot delete') {
                                this.$emit('deleted', false);
                                this.$bvModal.show('cannot-delete-client');
                            } else {
                                this.$bvModal.show('success-delete-client');
                                this.fetchClients();
                            }
                            this.$emit('deleted', false);
                            return response;
                        },
                        error => {
                            this.$emit('deleted', false);
                            this.showError(error);
                        }
                    );
                }
            },
            clientAdded() {
                this.items.unshift(this.clientAdded);
            },
            currentPage: {
                handler() {
                    this.fetchClients();
                }
            },
            perPage: {
                handler() {
                    this.fetchClients();
                }
            },
            query: {
                handler() {
                    if (this.query == '') {
                        this.filterList = this.filterList.filter(function (value) {
                            return value.key != 'country';
                        });
                        this.filterQueryGenerator(this.filterList);
                        this.fetchClients();
                    } else {
                        const code = this.countries.find(record => record.name == this.query);
                        if (code) {
                            this.debouncedFetchClient('country', code.code);
                        }
                    }
                }
            }
        }
    };
</script>

<style type="scss">
    @import '../../../assets/style/css/appStyle.css';
    @import '../../../assets/style/css/network/clients/table.css';
    @import '../../../assets/style/css/share/table.css';
</style>
